// import { DateTimeConverter } from "@/shared";
import { Label } from "@fluentui/react-components";
// import { Tooltip } from "@fluentui/react-tooltip";
import { useTranslation } from "react-i18next";
import { IAvailabilityProps } from "./Model";
import { AvailabilityDescWrapper, AvailabilityWrapper } from "./Style";
import { DateTimeFormatHelper } from "@/utilities";
import ScrollDismissTooltip from "@/components/ui/Tooltip";

const Availability = (props: IAvailabilityProps) => {
  const { t } = useTranslation();
  const meetingDeclines = props.resource?.permission?.meetingDeclines || [];
  const availableMeeting =
    (props.meetingInfos?.length || 0) - meetingDeclines.length;
  const hitRate: string = `${availableMeeting}/${
    props.meetingInfos?.length || 0
  }`;
  const isAcceptSelect = props.resource?.permission?.isAcceptSelectRecurring
    ? props.resource?.permission?.isAcceptSelectRecurring(
        props.meetingInfos?.length || 0
      )
    : true;

  const renderTextDesc = () => {
    return <AvailabilityDescWrapper className="AvailabilityDescWrapper">
        <Label>{t("Available occurrences of the series")}: {hitRate}</Label>
        <Label>{t("Conflicting Occurrences")}:</Label>
        {meetingDeclines.map((item, index) => <Label key={index}>{DateTimeFormatHelper.FormatByCulture(new Date(item?.startTime || ""), props.dateFormat || undefined)}</Label>)}
      </AvailabilityDescWrapper>
  }

  return (
    <AvailabilityWrapper className="AvailabilityWrapper">
      {availableMeeting && isAcceptSelect &&
      availableMeeting < (props.meetingInfos?.length || 0) ? (
         <ScrollDismissTooltip  relationship="label" content={renderTextDesc()}>
          <div>{`${t("Availability")}: ${hitRate}`}</div>
        </ScrollDismissTooltip>
      ) : (
        <div>{`${t("Availability")}: ${hitRate}`}</div>
      )}
    </AvailabilityWrapper>
  );
};

export default Availability;
